import { useEffect, useState } from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { baseURL, post, postForm } from "../../Util/axios_helper";
import { KendoFileUpload } from "../../Kendo/kendo_fileupload";
import { KendoSingleFileUpload } from "../../Kendo/kendo_single_fileupload";
import Toast from "../../Util/toastify";
import { Button, Loader } from "../../Util/common";
import { getContractList, showLoading } from "./contract_slice";
import { useDispatch, useSelector } from "react-redux";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const ContractPage = () => {
  useEffect(() => {
    $('#contract').addClass('active');
    return () => {
      $('#contract').removeClass('active');
    };
  }, []);
  const dispatch = useDispatch();
  const [tentativeInvoice, setTentativeInvoice] = useState(null);
  const [guaranteedInvoice, setGuaranteedInvoice] = useState(null);
  const [finalInvoice, setFinalInvoice] = useState(null);
  const [isShown, setisShown] = useState(false);
  const [mobilenumber, setmobilenumber] = useState(null);
  const [EventName, setEventName] = useState(null);
  const [EventDate, setEventDate] = useState(null);
  const [EventID, setEventID] = useState(null);
  const [VersionHistoryList, SetVerisonHistoryList] = useState([]);
  const { contractlist, contractlistloaded } = useSelector(
    (state) => state.contract
  );
  const [clear, setClear] = useState(0);
  useEffect(() => {
    dispatch(getContractList());
  }, []);

  useEffect(() => {}, [contractlistloaded]);
  const handleTentativeInvoiceChange = (e) => {
    setTentativeInvoice(e.target.files[0]);
    setisShown(false);
  };

  const handleGuaranteedInvoiceChange = (e) => {
    setGuaranteedInvoice(e.target.files[0]);
    setisShown(false);
  };

  const handleFinalInvoiceChange = (e) => {
    setFinalInvoice(e.target.files[0]);
    setisShown(false);
  };

  const handleSubmit = (e) => {
    
    e.preventDefault();

    if (!tentativeInvoice && !guaranteedInvoice && !finalInvoice) {
      setisShown(true);
      return;
    }
    setisShown(false);
    
    dispatch(showLoading(false));
    const formData = new FormData();
    formData.append("TentativeContract", tentativeInvoice);
    formData.append("GuaranteedContract", guaranteedInvoice);
    formData.append("FinalInvoice", finalInvoice);
    formData.append("ClientMobileNumber", mobilenumber);
    formData.append("EventName", EventName);
    formData.append("EventDate", EventDate);
    formData.append("EventID", EventID);

    try {
      postForm(
        "ScheduledEventDetails/SaveDocument",
        formData,
        true,
        true,
        false
      ).then((e) => {
        dispatch(getContractList());
      });

      $("#Contract-Cancel").click();
    } catch (error) {
      Toast(error.Messsage, "Failed");
      $("#Contract-Cancel").click();
    }
  };

  const handleEditClick = (e) => {
    
    setmobilenumber(e.PhoneNumber);
    setEventName(e.EventType);
    setEventDate(e.EventDate);
    setEventID(e.EventID);

    $("#Contract_List").modal("show");
  };

  const clearForm = () => {
    setTentativeInvoice(null);
    setGuaranteedInvoice(null);
    setFinalInvoice(null);
    setmobilenumber(null);
    setEventName(null);
    setEventID(null);
    setEventDate(null);
    setisShown(false);
    setClear(clear + 1);
  };

  const onVersionHistoryClick = (e) => {
    const onVersionHistoryOpen = (eventId, contactnumber, documnettype) => {
      $("#VersionHistory_List").modal("show");
      GetContractHistoryDocument(eventId, contactnumber, documnettype);
    };
    $(".icn-version-history")
      .off("click")
      .on("click", function () {
        let eventId = $(this).data("event-id");
        let documnettype = $(this).data("documnet-type");
        let contactnumber = $(this).data("conatct-num");
        onVersionHistoryOpen(eventId, contactnumber, documnettype);
      });

    $(".icn-version-history-guaranteed")
      .off("click")
      .on("click", function () {
        let eventId = $(this).data("event-id");
        let documnettype = $(this).data("documnet-type");
        let contactnumber = $(this).data("conatct-num");
        onVersionHistoryOpen(eventId, contactnumber, documnettype);
      });

    $(".icn-version-history-finalinvoice")
      .off("click")
      .on("click", function () {
        let eventId = $(this).data("event-id");
        let documnettype = $(this).data("documnet-type");
        let contactnumber = $(this).data("conatct-num");
        onVersionHistoryOpen(eventId, contactnumber, documnettype);
      });
  };

  const GetContractHistoryDocument = async (
    eventId,
    mobileNumber,
    documentType
  ) => {
    try {
      const url = new URL(
        baseURL + "ScheduledEventDetails/GetContractHistoryDocument"
      );
      url.searchParams.append("EventId", eventId);
      url.searchParams.append("MobileNumber", mobileNumber);
      url.searchParams.append("DocumentType", documentType);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      SetVerisonHistoryList(data);
      return data;
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const handleDeleteClick = async (e) => {
    const modal = new bootstrap.Modal(
      document.getElementById("delete_document")
    );
    modal.show();
    const deleteButton = document.getElementById("deletedocButton");
    deleteButton.onclick = async () => {
      const response = await fetch(
        baseURL +
          `ScheduledEventDetails/DeleteContractDocument?Id=${e.MyDocumentID}`
      );
      if (response.ok) {
        Toast("Document deleted successfully", "success");
        modal.hide();
        dispatch(getContractList());
      } else {
        Toast("Failed to delete Document", "error");
        dispatch(getContractList());
      }
    };
  };

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Contract List</h3>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="row">
            {contractlistloaded ? (
              <KendoGrid
                name={"contract_list"}
                // url={baseURL + "Configuration/ContractList"}
                data={contractlist}
                columns={[
                  {
                    field: "Id",
                    title: "S.No",
                    filterable: false,
                    width: "60px",
                  },

                  {
                    field: "EventID",
                    //filterable: false,
                    hidden: true,
                  },

                  {
                    field: "FirstName",
                    title: "Client",
                    width: "82px",
                  },
                  {
                    field: "PhoneNumber",
                    title: "Mobile",
                    width: "100px",
                  },
                  {
                    field: "EventDate",
                    title: "Event Date",
                    width: "100px",
                  },
                  {
                    field: "EventType",
                    title: "Event Type",
                  },
                  {
                    field: "TentativeDocumentDownloadLink",
                    title: "Tentative",
                    width: "80px",
                    template: function (dataItem) {
                      if (dataItem.TentativeDocumentDownloadLink) {
                        return `<a href="#" title="Version History"  data-event-id="${dataItem.EventID}" data-conatct-num= "${dataItem.PhoneNumber}" data-documnet-type= "TentativeContract"      class="icn-version-history">
                        <img src='assets/img/openfolder.png' width=20 height=20 />
                        </a> <a href="${dataItem.TentativeDocumentDownloadLink}" target="_blank" title="Download Document"  >
                        <img src='assets/img/docs.png' width=20 height=20 />
                        </a>`;
                      }
                      return "";
                    },
                  },
                  {
                    field: "FullyExecutedDocumentDownloadLink",
                    title: "Guaranteed",
                    width: "80px",
                    template: function (dataItem) {
                      if (dataItem.FullyExecutedDocumentDownloadLink) {
                        return `<a href="#" title="Version History"  data-event-id="${dataItem.EventID}" data-conatct-num= "${dataItem.PhoneNumber}" data-documnet-type= "GuaranteedContract" class="icn-version-history-guaranteed">
                        <img src='assets/img/openfolder.png' width=20 height=20 />                    
                              </a>
                              </a> <a href="${dataItem.FullyExecutedDocumentDownloadLink}" target="_blank" title="Download Document" >
                              <img src='assets/img/docs.png' width=20 height=20 />                              </a>`;
                      }
                      return "";
                    },
                  },
                  {
                    field: "FullInvoiceDocumentDownloadLink",
                    title: "Final Invoice",
                    width: "80px",
                    template: function (dataItem) {
                      if (dataItem.FullInvoiceDocumentDownloadLink) {
                        return `<a href="#" title="Version History" data-event-id="${dataItem.EventID}" data-conatct-num= "${dataItem.PhoneNumber}" data-documnet-type= "FinalInvoice" class="icn-version-history-finalinvoice">
                        <img src='assets/img/openfolder.png' width=20 height=20 />                        
                        </a>
                      </a> <a href="${dataItem.FullInvoiceDocumentDownloadLink}" target="_blank" title="Download Document">
                      <img src='assets/img/docs.png' width=20 height=20 />       
                      </a>`;
                      }
                      return "";
                    },
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={false}
                onEditClick={handleEditClick}
                onDataBound={onVersionHistoryClick}
              />
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div
          className="modal custom-modal fade"
          id="Contract_List"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update Contract</h5>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    clearForm();
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="tentativeInvoice" className="form-label">
                    Tentative Invoice
                  </label>
                  {/* <input
                    type="file"
                    className="form-control"
                    id="tentativeInvoice"
                    onChange={handleTentativeInvoiceChange}
                    name="tentativeInvoice"
                  /> */}
                  <KendoSingleFileUpload
                    onChange={handleTentativeInvoiceChange}
                    name="tentativeInvoice"
                    id="tentative"
                    clearWhen={clear}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="guaranteedInvoice" className="form-label">
                    Guaranteed Invoice
                  </label>
                  {/* <input
                    type="file"
                    className="form-control"
                    id="guaranteedInvoice"
                    onChange={handleGuaranteedInvoiceChange}
                    name="guaranteedInvoice"
                  /> */}
                  <KendoSingleFileUpload
                    onChange={handleGuaranteedInvoiceChange}
                    name="guaranteedInvoice"
                    clearWhen={clear}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="finalInvoice" className="form-label">
                    Final Invoice
                  </label>
                  {/* <input
                    type="file"
                    className="form-control"
                    id="finalInvoice"
                    name="finalInvoice"
                    onChange={handleFinalInvoiceChange}
                  /> */}
                  <KendoSingleFileUpload
                    name={"finalInvoice"}
                    onChange={handleFinalInvoiceChange}
                    clearWhen={clear}
                  />
                </div>
                <div style={{ display: isShown ? "block" : "none" }}>
                  <p style={{ color: "red" }}>
                    Please select at least one file
                  </p>
                </div>
                <div className="text-end">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    id="Contract-Cancel"
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  <Button type="submit" name={"Submit"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        className="modal custom-modal fade"
        id="VersionHistory_List"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Version History</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <KendoGrid
                name={"contract_list"}
                data={VersionHistoryList}
                schema={{}}
                columns={[
                  {
                    field: "MyDocumentID",

                    filterable: false,
                    hidden: true,
                  },

                  {
                    field: "DocumentName",
                    title: "Document Name",
                    template: function (dataItem) {
                      if (dataItem.DocumentDownloadLink) {
                        return `<a href="${dataItem.DocumentDownloadLink}" target="_blank" title="Download Document" style="text-decoration: underline;">
                                  ${dataItem.DocumentName}
                                </a>`;
                      }
                      return dataItem.DocumentName;
                    },
                  },

                  {
                    field: "DocumentType",
                    title: "Document Type",
                  },
                  {
                    field: "DocumentVersion",
                    title: "Document Version",
                  },
                ]}
                showOptions={true}
                showEdit={false}
                showDelete={true}
                onDeleteClick={(e) => {
                  handleDeleteClick(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade"
        id="delete_document"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>Delete Confirmation</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div className="row justify-content-center">
                <div className="col-auto">
                  <a
                    href="#"
                    data-bs-dismiss="modal"
                    className="butn-dark2 mr-2"
                  >
                    Cancel
                  </a>
                </div>
                <div className="col-auto">
                  <a id="deletedocButton" className="butn-dark2">
                    Delete
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
